import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import classes from './App.module.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <div className={classes.root}>
      <App />
    </div>
  </React.StrictMode>
);

// Register service worker for PWA offline support and asset caching.
// CRA's Workbox plugin generates service-worker.js at build time.
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('[PWA] App is ready for offline use.');
  },
  onUpdate: (registration) => {
    // Notify user a new version is available (optional: show a toast/banner)
    console.log('[PWA] New version available. Reload to update.');
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});
